/* Aerowalk theme.js — vanilla, ingen afhængigheder */
(function () {
  'use strict';
  const cfg = window.aerowalk || { routes: {}, strings: {} };
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const fmt = (s, o) => String(s || '').replace(/\{(\w+)\}/g, (_, k) => (o[k] !== undefined ? o[k] : ''));

  /* ---------- Penge ---------- */
  function money(cents) {
    const f = cfg.moneyFormat || '{{amount_no_decimals}} kr.';
    const n = cents / 100;
    const noDec = Math.round(n).toLocaleString('da-DK');
    const dec = n.toLocaleString('da-DK', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return f
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, noDec)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, noDec)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, dec)
      .replace(/\{\{\s*amount\s*\}\}/, dec);
  }
  window.aerowalkMoney = money;

  /* ---------- Fælles størrelse ----------
     Størrelsen deles af headeren, kategorifilteret og produktsiden. Den
     gemmes i localStorage, fordi den skal kunne huskes til næste besøg —
     det er kun forsvarligt, når den altid står synligt i headeren og kan
     ryddes derfra. sessionStorage læses stadig, så gamle valg ikke tabes. */
  const KEY = 'aw-size';
  const sizeStore = {
    get() {
      try { return localStorage.getItem(KEY) || sessionStorage.getItem(KEY) || null; }
      catch (e) { return null; }
    },
    set(v, source) {
      try {
        if (v) localStorage.setItem(KEY, v); else localStorage.removeItem(KEY);
        sessionStorage.removeItem(KEY);
      } catch (e) {}
      document.dispatchEvent(new CustomEvent('aw:size', { detail: { size: v, source: source } }));
    }
  };
  window.aerowalkSize = sizeStore;

  /* ---------- Skuffer & overlay ---------- */
  const overlay = $('[data-overlay]');
  let openDrawer = null;
  function closeAll() {
    $$('.drawer.is-open').forEach(d => { d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); });
    $$('.search-overlay.is-open, .video-modal.is-open').forEach(el => close(el));
    overlay && overlay.classList.remove('is-open');
    document.body.classList.remove('has-drawer');
    openDrawer = null;
  }
  function open(el) {
    if (!el) return;
    closeAll();
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    overlay && overlay.classList.add('is-open');
    document.body.classList.add('has-drawer');
    openDrawer = el;
    const focus = el.querySelector('[data-autofocus], input, button');
    focus && setTimeout(() => focus.focus(), 60);
  }
  function close(el) {
    if (!el) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    if (el.classList.contains('video-modal')) { const v = el.querySelector('video'); if (v) { v.pause(); v.removeAttribute('src'); v.load(); } const f = el.querySelector('iframe'); if (f) f.removeAttribute('src'); }
    if (!$('.drawer.is-open') && !$('.search-overlay.is-open') && !$('.video-modal.is-open')) {
      overlay && overlay.classList.remove('is-open');
      document.body.classList.remove('has-drawer');
    }
  }
  document.addEventListener('click', e => {
    const opener = e.target.closest('[data-drawer-open]');
    if (opener) { e.preventDefault(); open(document.getElementById(opener.dataset.drawerOpen)); return; }
    const closer = e.target.closest('[data-drawer-close]');
    if (closer) { e.preventDefault(); closeAll(); return; }
    if (e.target === overlay) closeAll();
  });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeAll(); });

  /* ---------- Video-modal ---------- */
  document.addEventListener('click', e => {
    const btn = e.target.closest('[data-video-open]');
    if (!btn) return;
    e.preventDefault();
    const modal = $('#VideoModal');
    if (!modal) return;
    const src = btn.dataset.videoOpen;
    const video = modal.querySelector('video');
    const iframe = modal.querySelector('iframe');
    if (/youtube\.com|youtu\.be|vimeo\.com/.test(src)) {
      let embed = src;
      const yt = src.match(/(?:v=|youtu\.be\/|embed\/)([\w-]{6,})/);
      const vm = src.match(/vimeo\.com\/(\d+)/);
      if (yt) embed = 'https://www.youtube.com/embed/' + yt[1] + '?autoplay=1&rel=0';
      else if (vm) embed = 'https://player.vimeo.com/video/' + vm[1] + '?autoplay=1';
      video.hidden = true; iframe.hidden = false; iframe.src = embed;
    } else {
      iframe.hidden = true; video.hidden = false;
      modal.querySelector('.video-modal__frame').style.aspectRatio = '';
      video.addEventListener('loadedmetadata', () => {
        if (video.videoWidth && video.videoHeight) {
          modal.querySelector('.video-modal__frame').style.aspectRatio = video.videoWidth + ' / ' + video.videoHeight;
        }
      }, { once: true });
      video.src = src; video.play().catch(() => {});
    }
    open(modal);
  });

  /* ---------- Hero-film: autoplay uden lyd, lyd på klik ---------- */
  class HeroVideo {
    constructor(root) {
      this.root = root;
      this.video = root.querySelector('[data-hero-media]');
      this.tools = root.querySelector('[data-hero-tools]');
      this.soundBtn = root.querySelector('[data-hero-sound]');
      this.pauseBtn = root.querySelector('[data-hero-pause]');
      if (!this.video) return;
      const conn = navigator.connection || {};
      const slow = conn.saveData === true || /2g/.test(conn.effectiveType || '');
      this.wantsAutoplay = root.dataset.autoplay !== 'false' && !slow;
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.unmuted = false;

      this.video.muted = true;
      this.video.loop = true;
      this.video.setAttribute('muted', '');
      this.video.addEventListener('playing', () => this.root.classList.add('is-playing'), { once: true });
      this.video.addEventListener('ended', () => this.reset());

      $$('[data-hero-start]', root).forEach(b => b.addEventListener('click', e => { e.preventDefault(); e.stopPropagation(); this.startWithSound(); }));
      root.addEventListener('click', e => { if (!this.unmuted && !e.target.closest('[data-hero-tools]')) this.startWithSound(); });

      this.soundBtn && this.soundBtn.addEventListener('click', e => { e.stopPropagation(); this.toggleSound(); });
      this.pauseBtn && this.pauseBtn.addEventListener('click', e => { e.stopPropagation(); this.togglePlay(); });

      if (this.wantsAutoplay && !this.reduced) {
        this.video.preload = 'auto';
        const tryPlay = () => this.video.play().catch(() => {});
        if (this.video.readyState >= 2) tryPlay(); else this.video.addEventListener('loadeddata', tryPlay, { once: true });
        this.video.load();
      }
      this.observe();
    }
    observe() {
      if (!('IntersectionObserver' in window)) return;
      new IntersectionObserver(([en]) => {
        if (this.unmuted) return;
        if (en.isIntersecting) { if (this.wantsAutoplay && !this.reduced) this.video.play().catch(() => {}); }
        else this.video.pause();
      }, { threshold: 0.15 }).observe(this.root);
    }
    startWithSound() {
      this.unmuted = true;
      this.video.loop = false;
      this.video.muted = false;
      this.video.removeAttribute('muted');
      this.video.volume = 1;
      this.video.currentTime = 0;
      this.video.play().catch(() => {});
      this.root.classList.add('is-unmuted', 'is-playing');
      this.root.classList.remove('is-muted', 'is-paused');
      if (this.tools) this.tools.hidden = false;
    }
    reset() {
      this.unmuted = false;
      this.video.loop = true;
      this.video.muted = true;
      this.video.setAttribute('muted', '');
      this.video.currentTime = 0;
      this.root.classList.remove('is-unmuted', 'is-muted', 'is-paused');
      if (this.tools) this.tools.hidden = true;
      if (this.wantsAutoplay && !this.reduced) this.video.play().catch(() => {});
    }
    toggleSound() {
      this.video.muted = !this.video.muted;
      this.root.classList.toggle('is-muted', this.video.muted);
      this.soundBtn.setAttribute('aria-label', this.video.muted ? 'Slå lyd til' : 'Slå lyd fra');
    }
    togglePlay() {
      if (this.video.paused) { this.video.play().catch(() => {}); this.root.classList.remove('is-paused'); }
      else { this.video.pause(); this.root.classList.add('is-paused'); }
      this.pauseBtn.setAttribute('aria-label', this.video.paused ? 'Afspil' : 'Sæt på pause');
    }
  }
  $$('[data-hero-video]').forEach(r => { try { new HeroVideo(r); } catch (err) { console.error('[aerowalk] hero', err); } });

  /* ---------- Størrelsesvælger i headeren ---------- */
  class SizeSwitch {
    constructor(root) {
      this.root = root;
      this.btn = root.querySelector('[data-size-switch-toggle]');
      this.pop = root.querySelector('[data-size-switch-pop]');
      this.idle = root.querySelector('[data-size-idle]');
      this.setLabel = root.querySelector('[data-size-set]');
      this.value = root.querySelector('[data-size-value]');
      this.clearBtn = root.querySelector('[data-size-switch-clear]');
      this.picks = $$('[data-size-switch-pick]', root);

      this.btn.addEventListener('click', e => { e.stopPropagation(); this.toggle(); });
      this.picks.forEach(b => b.addEventListener('click', () => {
        const v = b.dataset.sizeSwitchPick;
        sizeStore.set(sizeStore.get() === v ? null : v, 'switch');
        this.close();
        this.act();
      }));
      this.clearBtn.addEventListener('click', () => { sizeStore.set(null, 'switch'); this.close(); this.act(); });
      document.addEventListener('click', e => { if (!this.root.contains(e.target)) this.close(); });
      document.addEventListener('keydown', e => { if (e.key === 'Escape') this.close(); });
      document.addEventListener('aw:size', () => this.render());
      this.render();
    }
    toggle() { this.pop.hidden ? this.open() : this.close(); }
    open() {
      $$('[data-size-switch-pop]').forEach(p => { if (p !== this.pop) p.hidden = true; });
      this.pop.hidden = false;
      this.btn.setAttribute('aria-expanded', 'true');
    }
    close() { this.pop.hidden = true; this.btn.setAttribute('aria-expanded', 'false'); }
    render() {
      const v = sizeStore.get();
      this.root.classList.toggle('is-set', !!v);
      this.idle.hidden = !!v;
      this.setLabel.hidden = !v;
      if (v) this.value.textContent = v;
      this.clearBtn.hidden = !v;
      this.picks.forEach(b => {
        const on = b.dataset.sizeSwitchPick === v;
        b.classList.toggle('is-selected', on);
        b.setAttribute('aria-pressed', on);
      });
    }
    // Vælgeren skal gøre noget synligt, uanset hvor man står. På en
    // kategoriside filtrerer gitteret selv; ellers sendes man derhen.
    act() {
      if (document.querySelector('[data-collection]')) return;
      const v = sizeStore.get();
      const base = (cfg.routes && cfg.routes.allProducts) || '/collections/all';
      window.location.href = v ? base + '?str=' + encodeURIComponent(v) : base;
    }
  }
  $$('[data-size-switch]').forEach(r => { try { new SizeSwitch(r); } catch (err) { console.error('[aerowalk] størrelsesvælger', err); } });

  /* ---------- Søgning ---------- */
  const searchOverlay = $('#SearchOverlay');
  if (searchOverlay) {
    const input = searchOverlay.querySelector('input[type="search"]');
    const results = searchOverlay.querySelector('[data-search-results]');
    let t;
    input && input.addEventListener('input', () => {
      clearTimeout(t);
      const q = input.value.trim();
      if (q.length < 2) { results.innerHTML = ''; return; }
      t = setTimeout(async () => {
        try {
          const url = (cfg.routes.predictive || '/search/suggest') + '?q=' + encodeURIComponent(q) + '&resources[type]=product,collection,page&resources[limit]=6&resources[options][unavailable_products]=last';
          const r = await fetch(url, { headers: { Accept: 'application/json' } });
          const data = await r.json();
          const p = (data.resources.results.products || []);
          const c = (data.resources.results.collections || []);
          const pg = (data.resources.results.pages || []);
          let html = '';
          p.forEach(x => {
            html += `<a class="search-result" href="${x.url}"><img class="search-result__img" src="${x.featured_image ? x.featured_image.url + (x.featured_image.url.includes('?') ? '&' : '?') + 'width=128' : ''}" alt="" loading="lazy"><span><span class="search-result__title">${x.title}</span><br><span class="search-result__meta">${x.price ? money(Math.round(parseFloat(x.price) * 100)) : ''}${x.available === false ? ' · ' + (cfg.strings.soldOut || 'Udsolgt') : ''}</span></span></a>`;
          });
          [...c, ...pg].forEach(x => { html += `<a class="search-result" href="${x.url}"><span class="search-result__title">${x.title}</span></a>`; });
          if (!html) html = '<p class="muted">Ingen resultater. Prøv fx “Supersoft” eller en størrelse.</p>';
          results.innerHTML = html;
        } catch (err) { results.innerHTML = ''; }
      }, 220);
    });
  }

  /* ---------- Kurv ---------- */
  const cart = {
    async fetchSections(sections) {
      const r = await fetch(window.location.pathname + '?sections=' + sections.join(','));
      return r.json();
    },
    renderSections(json) {
      Object.keys(json || {}).forEach(id => {
        const html = json[id];
        if (!html) return;
        const tmp = document.createElement('div');
        tmp.innerHTML = html;
        const fresh = tmp.querySelector('#shopify-section-' + id) || tmp.firstElementChild;
        const current = document.getElementById('shopify-section-' + id);
        if (id === 'cart-drawer' && current && fresh) {
          const wasOpen = current.querySelector('.drawer.is-open');
          const inner = fresh.querySelector('[data-cart-drawer-inner]');
          const target = current.querySelector('[data-cart-drawer-inner]');
          if (inner && target) target.innerHTML = inner.innerHTML;
          if (wasOpen) current.querySelector('.drawer').classList.add('is-open');
        } else if (current && fresh) {
          current.innerHTML = fresh.innerHTML;
        }
      });
    },
    async updateCount() {
      try {
        const r = await fetch(cfg.routes.cart + '.js'); const c = await r.json();
        $$('[data-cart-count]').forEach(el => { el.textContent = c.item_count; el.dataset.count = c.item_count; });
        return c;
      } catch (e) { return null; }
    },
    async add(formData, btn) {
      formData.append('sections', 'cart-drawer');
      formData.append('sections_url', window.location.pathname);
      btn && btn.classList.add('btn--loading');
      try {
        const r = await fetch(cfg.routes.cartAdd + '.js', { method: 'POST', body: formData, headers: { Accept: 'application/json' } });
        const data = await r.json();
        if (data.status) { throw new Error(data.description || data.message || 'Kunne ikke lægge i kurven'); }
        this.renderSections(data.sections);
        await this.updateCount();
        if (cfg.cartDrawer) {
          const d = $('#CartDrawer');
          // Lægger man til inde fra skuffen, skal den ikke lukkes og åbnes igen.
          if (d && !d.classList.contains('is-open')) open(d);
        } else {
          window.location.href = cfg.routes.cart;
        }
        return data;
      } catch (err) {
        alert(err.message);
      } finally { btn && btn.classList.remove('btn--loading'); }
    },
    async change(key, quantity) {
      const r = await fetch(cfg.routes.cartChange + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity, sections: 'cart-drawer,main-cart', sections_url: window.location.pathname }) });
      const data = await r.json();
      this.renderSections(data.sections);
      $$('[data-cart-count]').forEach(el => { el.textContent = data.item_count; el.dataset.count = data.item_count; });
    }
  };
  window.aerowalkCart = cart;

  document.addEventListener('click', e => {
    const qb = e.target.closest('[data-qty-change]');
    if (qb) {
      e.preventDefault();
      const line = qb.closest('[data-line-key]');
      const input = line.querySelector('[data-qty-input]');
      const q = Math.max(0, parseInt(input.value || '0', 10) + parseInt(qb.dataset.qtyChange, 10));
      line.style.opacity = '.5';
      cart.change(line.dataset.lineKey, q);
      return;
    }
    const rm = e.target.closest('[data-line-remove]');
    if (rm) { e.preventDefault(); const line = rm.closest('[data-line-key]'); line.style.opacity = '.5'; cart.change(line.dataset.lineKey, 0); }
  });
  document.addEventListener('change', e => {
    const input = e.target.closest('[data-qty-input]');
    if (input) { const line = input.closest('[data-line-key]'); cart.change(line.dataset.lineKey, Math.max(0, parseInt(input.value || '0', 10))); }
  });

  /* ---------- Produktformular (størrelsesgitter) ---------- */
  class ProductForm {
    constructor(root) {
      this.root = root;
      this.form = root.querySelector('form[data-product-form]');
      const data = root.querySelector('[data-variants]');
      // Pakkeprodukter har ingen almindelig købsformular — de bruger
      // størrelsesvælgeren i BundleBuilder. Uden dette tjek kastede
      // konstruktøren en fejl, der stoppede resten af theme.js, så
      // pakkesiderne slet ikke kunne lægges i kurven.
      if (!this.form || !data) { this.disabled = true; return; }
      this.variants = JSON.parse(data.textContent);
      this.optionIndex = parseInt(root.dataset.sizeOption || '0', 10);
      this.idInput = this.form.querySelector('input[name="id"]');
      this.btn = this.form.querySelector('[data-add-to-cart]');
      this.btnText = this.btn.querySelector('[data-add-text]');
      this.priceEl = root.querySelector('[data-price]');
      this.compareEl = root.querySelector('[data-compare-price]');
      this.note = root.querySelector('[data-size-note]');
      this.notify = root.querySelector('[data-notify]');
      this.notifySize = root.querySelector('[data-notify-size]');
      this.buyBar = document.querySelector('[data-buy-bar]');
      this.sizeButtons = $$('[data-size-value]', root);
      this.otherSelects = $$('[data-option-select]', root);
      this.sizeButtons.forEach(b => b.addEventListener('click', () => this.select(b)));
      this.otherSelects.forEach(s => s.addEventListener('change', () => this.update()));
      this.form.addEventListener('submit', e => { e.preventDefault(); this.submit(); });
      const wanted = new URLSearchParams(location.search).get('str') || sizeStore.get();
      if (wanted) { const b = this.sizeButtons.find(x => x.dataset.sizeValue === wanted); if (b) { this.sizeButtons.forEach(x => { x.classList.remove('is-selected'); x.setAttribute('aria-pressed', 'false'); }); b.classList.add('is-selected'); b.setAttribute('aria-pressed', 'true'); } }
      this.update();
      this.stickyBar();
    }
    select(btn) {
      this.sizeButtons.forEach(b => { b.classList.remove('is-selected'); b.setAttribute('aria-pressed', 'false'); });
      btn.classList.add('is-selected'); btn.setAttribute('aria-pressed', 'true');
      this.update();
    }
    currentOptions() {
      const opts = [];
      const selectedSize = this.sizeButtons.find(b => b.classList.contains('is-selected'));
      const n = parseInt(this.root.dataset.optionCount || '1', 10);
      for (let i = 0; i < n; i++) {
        if (i === this.optionIndex) opts[i] = selectedSize ? selectedSize.dataset.sizeValue : null;
        else { const s = this.otherSelects.find(x => parseInt(x.dataset.optionSelect, 10) === i); opts[i] = s ? s.value : (this.root.dataset['option' + i] || null); }
      }
      return opts;
    }
    findVariant(opts) {
      return this.variants.find(v => opts.every((o, i) => o === null || v.options[i] === o));
    }
    update() {
      const opts = this.currentOptions();
      const sizeChosen = opts[this.optionIndex] !== null;
      const v = sizeChosen ? this.findVariant(opts) : null;
      const s = cfg.strings;
      // Opdatér udsolgt/få tilbage-tilstande ud fra de andre valg
      this.sizeButtons.forEach(b => {
        const test = opts.slice(); test[this.optionIndex] = b.dataset.sizeValue;
        const vv = this.findVariant(test);
        b.classList.toggle('is-soldout', !vv || !vv.available);
        b.classList.toggle('is-low', !!(vv && vv.available && vv.inventory_management && vv.inventory_quantity > 0 && vv.inventory_quantity <= 2));
      });
      if (!sizeChosen) {
        this.btnText.textContent = s.chooseSize;
        this.btn.disabled = false; this.btn.dataset.state = 'choose';
        this.note && (this.note.hidden = true);
        this.notify && (this.notify.hidden = true);
        this.updateBar(null, null);
        return;
      }
      if (v) this.idInput.value = v.id;
      const available = v && v.available;
      this.btn.dataset.state = available ? 'ok' : 'soldout';
      this.btn.disabled = !available;
      this.btnText.textContent = available ? (s.addToCart + ' — ' + money(v.price)) : s.soldOut;
      if (v && this.priceEl) this.priceEl.textContent = money(v.price);
      if (v && this.compareEl) { if (v.compare_at_price && v.compare_at_price > v.price) { this.compareEl.textContent = money(v.compare_at_price); this.compareEl.hidden = false; } else this.compareEl.hidden = true; }
      const size = opts[this.optionIndex];
      if (this.note) {
        let msg = '';
        if (!available) msg = `Str. ${size} er udsolgt lige nu. <a href="#" data-notify-open>Skriv dig op</a>, så får du besked samme dag, den er hjemme.`;
        else if (v.inventory_management && v.inventory_quantity > 0 && v.inventory_quantity <= 2) msg = `Str. ${size} har kun ${v.inventory_quantity} par tilbage.`;
        this.note.hidden = !msg; this.note.querySelector('[data-note-text]').innerHTML = msg;
      }
      if (this.notify) { this.notify.hidden = available; if (this.notifySize) this.notifySize.value = size; this.notify.dataset.variantId = v ? v.id : ''; this.notify.dataset.size = size || ''; }
      this.updateBar(v, size);
    }
    updateBar(v, size) {
      if (!this.buyBar) return;
      const t = this.buyBar.querySelector('[data-bar-sub]'); const p = this.buyBar.querySelector('[data-bar-price]'); const b = this.buyBar.querySelector('[data-bar-btn]');
      if (t) t.textContent = size ? `Str. ${size} · ${this.buyBar.dataset.title}` : this.buyBar.dataset.title;
      if (p && v) p.textContent = money(v.price);
      if (b) { b.textContent = !size ? cfg.strings.chooseSize : (v && v.available ? cfg.strings.addToCart : cfg.strings.soldOut); b.disabled = !!(size && (!v || !v.available)); }
    }
    stickyBar() {
      if (!this.buyBar || !('IntersectionObserver' in window)) return;
      document.body.classList.add('has-buy-bar');
      const io = new IntersectionObserver(([en]) => this.buyBar.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0), { threshold: 0 });
      io.observe(this.btn);
      const bb = this.buyBar.querySelector('[data-bar-btn]');
      bb && bb.addEventListener('click', () => {
        if (this.btn.dataset.state === 'choose') { this.root.querySelector('.size-grid').scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
        this.submit(bb);
      });
    }
    async submit(btn) {
      if (this.btn.dataset.state === 'choose') { this.root.querySelector('.size-grid').classList.add('is-shake'); setTimeout(() => this.root.querySelector('.size-grid').classList.remove('is-shake'), 500); this.root.querySelector('.size-grid').scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
      if (this.btn.disabled) return;
      const fd = new FormData(this.form);
      await cart.add(fd, btn || this.btn);
    }
  }
  const boot = (label, fn) => { try { fn(); } catch (err) { console.error('[aerowalk] ' + label, err); } };
  boot('produktformular', () => $$('[data-product]').forEach(r => new ProductForm(r)));

  /* ---------- Produktgalleri: klik på et miniaturebillede ----------
     Lå før som en inline-scriptblok i sektionen, men den stod uden for
     .pdp, så document.currentScript.closest('.pdp') gav null, og
     galleriet virkede på ingen produktside. */
  $$('[data-product]').forEach(root => {
    const main = root.querySelector('[data-main-photo] img');
    const thumbs = $$('[data-thumb]', root);
    if (!main || !thumbs.length) return;
    thumbs.forEach(t => t.addEventListener('click', () => {
      thumbs.forEach(x => x.classList.remove('is-active'));
      t.classList.add('is-active');
      main.srcset = '';
      main.src = t.dataset.thumb;
    }));
  });
  document.addEventListener('click', e => {
    const a = e.target.closest('[data-notify-open]');
    if (a) { e.preventDefault(); const n = a.closest('[data-product]') && a.closest('[data-product]').querySelector('[data-notify]'); if (n) { n.hidden = false; n.querySelector('input[type="email"]').focus(); } }
  });

  /* ---------- Skriv mig op → Klaviyo-liste ----------
     Er der sat et liste-ID på produktsektionen, tilmeldes mailen listen i Klaviyo med produkt,
     størrelse og variant som egenskaber, og hændelsen "Skriv mig op" gemmes på profilen.
     Uden liste-ID, eller hvis Klaviyo svarer med en fejl, sendes formularen som før (mail til butikken). */
  document.addEventListener('submit', async e => {
    const form = e.target.closest('#NotifyForm');
    if (!form) return;
    const box = form.closest('[data-notify]');
    const list = box && box.dataset.klList, company = box && box.dataset.klCompany;
    if (!list || !company) return;
    e.preventDefault();
    const input = form.querySelector('input[type="email"]');
    const email = (input.value || '').trim();
    if (!email) { input.focus(); return; }
    const btn = form.querySelector('button[type="submit"]');
    if (btn) btn.disabled = true;
    const props = {
      'Skriv mig op: produkt': box.dataset.productTitle || '',
      'Skriv mig op: størrelse': box.dataset.size || '',
      'Skriv mig op: variant-id': box.dataset.variantId || '',
      'Skriv mig op: link': box.dataset.productUrl || ''
    };
    const headers = { 'Content-Type': 'application/vnd.api+json', 'revision': '2024-10-15' };
    const base = 'https://a.klaviyo.com/client/';
    const q = '/?company_id=' + encodeURIComponent(company);
    try {
      const r = await fetch(base + 'subscriptions' + q, { method: 'POST', headers, body: JSON.stringify({ data: {
        type: 'subscription',
        attributes: { custom_source: 'Skriv mig op', profile: { data: { type: 'profile', attributes: {
          email, properties: props
        } } } },
        relationships: { list: { data: { type: 'list', id: list } } }
      } }) });
      if (!r.ok) throw new Error('Klaviyo ' + r.status);
      fetch(base + 'events' + q, { method: 'POST', headers, body: JSON.stringify({ data: {
        type: 'event',
        attributes: {
          properties: { Produkt: props['Skriv mig op: produkt'], 'Størrelse': props['Skriv mig op: størrelse'], VariantID: props['Skriv mig op: variant-id'], Link: props['Skriv mig op: link'] },
          metric: { data: { type: 'metric', attributes: { name: 'Skriv mig op' } } },
          profile: { data: { type: 'profile', attributes: { email } } }
        }
      } }) }).catch(() => {});
      if (box.dataset.variantId) fetch(base + 'back-in-stock-subscriptions' + q, { method: 'POST', headers, body: JSON.stringify({ data: {
        type: 'back-in-stock-subscription',
        attributes: { channels: ['EMAIL'], profile: { data: { type: 'profile', attributes: { email } } } },
        relationships: { variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + box.dataset.variantId } } }
      } }) }).catch(() => {});
      if (box.dataset.klMail !== 'false') fetch(form.action.split('#')[0], { method: 'POST', body: new FormData(form), headers: { 'Accept': 'text/html' } }).catch(() => {});
      form.hidden = true;
      const done = box.querySelector('[data-notify-done]'); if (done) done.hidden = false;
    } catch (err) {
      form.submit();
    }
  });

  /* ---------- Pakkevælger ---------- */
  class BundleBuilder {
    constructor(root) {
      this.root = root;
      this.variants = JSON.parse(root.querySelector('[data-variants]').textContent);
      this.rows = $$('[data-bundle-row]', root);
      this.priceEl = root.querySelector('[data-bundle-price]');
      this.compareEl = root.querySelector('[data-bundle-compare]');
      this.saveEl = root.querySelector('[data-bundle-save]');
      this.btn = root.querySelector('[data-bundle-add]');
      this.idInput = root.querySelector('input[name="id"]');
      this.rows.forEach((row, i) => $$('[data-size-value]', row).forEach(b => b.addEventListener('click', () => {
        $$('[data-size-value]', row).forEach(x => { x.classList.remove('is-selected'); x.setAttribute('aria-pressed', 'false'); });
        b.classList.add('is-selected'); b.setAttribute('aria-pressed', 'true'); this.update();
      })));
      this.btn.addEventListener('click', e => { e.preventDefault(); this.submit(); });
      this.update();
    }
    selection() { return this.rows.map(row => { const b = $$('[data-size-value]', row).find(x => x.classList.contains('is-selected')); return b ? b.dataset.sizeValue : null; }); }
    find(sel) { return this.variants.find(v => sel.every((s, i) => s === null || v.options[i] === s)); }
    update() {
      const sel = this.selection();
      // markér udsolgte i hver række givet det andet valg
      this.rows.forEach((row, i) => $$('[data-size-value]', row).forEach(b => {
        const test = sel.slice(); test[i] = b.dataset.sizeValue; for (let j = 0; j < test.length; j++) if (j !== i && test[j] === null) test[j] = null;
        const v = this.find(test); b.classList.toggle('is-soldout', !v || !v.available);
      }));
      const complete = sel.every(s => s !== null);
      const v = complete ? this.find(sel) : null;
      if (v) {
        this.idInput.value = v.id;
        this.priceEl.textContent = money(v.price);
        const compare = parseInt(this.root.dataset.compare || '0', 10) || (v.compare_at_price || 0);
        if (this.compareEl) { this.compareEl.textContent = compare > v.price ? money(compare) : ''; this.compareEl.hidden = !(compare > v.price); }
        if (this.saveEl && compare > v.price) this.saveEl.textContent = 'Spar ' + money(compare - v.price);
      }
      this.btn.disabled = !(v && v.available);
      this.btn.querySelector('span').textContent = !complete ? (cfg.strings.bundleChoose || 'Vælg størrelse til begge par') : (v && v.available ? (cfg.strings.bundleAdd || 'Læg pakken i kurven') : (cfg.strings.bundleSoldOut || 'Udsolgt i den kombination'));
    }
    async submit() {
      if (this.btn.disabled) return;
      const fd = new FormData(); fd.append('id', this.idInput.value); fd.append('quantity', 1);
      await cart.add(fd, this.btn);
    }
  }
  boot('pakkestørrelser', () => $$('[data-bundle]').forEach(r => new BundleBuilder(r)));

  /* ---------- Forslag i kurven: tryk på en størrelse ---------- */
  document.addEventListener('click', async e => {
    const b = e.target.closest('[data-upsell-add]');
    if (!b) return;
    e.preventDefault();
    if (b.classList.contains('is-adding')) return;
    b.classList.add('is-adding');
    const fd = new FormData();
    fd.append('id', b.dataset.upsellAdd);
    fd.append('quantity', 1);
    try { await cart.add(fd); } finally { b.classList.remove('is-adding'); }
  });

  /* ---------- Kategoriside: filtre og "vis flere" ----------
     Alle kort i kollektionen står i HTML'en. Filteret arbejder derfor på hele
     listen, og "Vis flere" afdækker et hold ad gangen. Tidligere hentede den
     en ny side, så et størrelsesfilter kun ledte i de første 12 produkter. */
  class CollectionGrid {
    constructor(root) {
      this.root = root;
      this.grid = root.querySelector('[data-product-grid]');
      this.sizeButtons = $$('[data-filter-size]', root);
      this.stockToggle = root.querySelector('[data-filter-stock]');
      this.countEl = root.querySelector('[data-filter-count]');
      this.status = root.querySelector('[data-pagination-status]');
      this.more = root.querySelector('[data-reveal-more]');
      this.step = parseInt(root.dataset.reveal || '12', 10) || 12;
      this.revealed = this.step;
      // Et link med ?str=41 skal vinde over den huskede størrelse, ellers
      // viste headeren ét tal og gitteret et andet.
      const fromUrl = new URLSearchParams(location.search).get('str');
      this.size = fromUrl || sizeStore.get() || null;
      if (fromUrl && fromUrl !== sizeStore.get()) sizeStore.set(fromUrl, 'grid');
      this.stock = false;
      this.filters = {};

      this.sizeButtons.forEach(b => b.addEventListener('click', () => {
        this.size = this.size === b.dataset.filterSize ? null : b.dataset.filterSize;
        sizeStore.set(this.size, 'grid');
        this.revealed = this.step;
        this.apply();
        this.syncUrl();
      }));
      this.stockToggle && this.stockToggle.addEventListener('click', () => { this.stock = !this.stock; this.revealed = this.step; this.apply(); });
      $$('[data-filter-group]', root).forEach(g => {
        const key = g.dataset.filterGroup;
        $$('input[type="checkbox"]', g).forEach(c => c.addEventListener('change', () => {
          this.filters[key] = $$('input:checked', g).map(x => x.value);
          this.revealed = this.step;
          this.apply();
        }));
      });
      $$('[data-filter-reset]', root).forEach(b => b.addEventListener('click', () => this.reset()));
      this.more && this.more.addEventListener('click', () => {
        this.revealed += this.step;
        this.apply();
        const first = this.matching()[this.revealed - this.step];
        first && first.scrollIntoView({ block: 'center', behavior: 'smooth' });
      });
      document.addEventListener('click', e => { if (!e.target.closest('.filter-dd')) $$('.filter-dd[open]', root).forEach(d => d.removeAttribute('open')); });
      document.addEventListener('aw:size', e => {
        if (e.detail.source === 'grid') return;
        this.size = e.detail.size;
        this.revealed = this.step;
        this.apply();
      });
      // Adressen skal følge det, gitteret viser, ellers giver et genindlæs
      // en anden størrelse end den, man lige valgte i headeren.
      document.addEventListener('aw:size', () => this.syncUrl());
      this.apply();
    }
    cards() { return $$('[data-product-card]', this.grid); }
    matches(card) {
      const avail = (card.dataset.available || '').split(',').filter(Boolean);
      const sizes = (card.dataset.sizes || '').split(',').filter(Boolean);
      // Et produkt uden størrelsesakse (fx fragt solgt som vare) hører ikke
      // med i et størrelsesfilter. Før slap de igennem og var det ene
      // "resultat", man fik.
      if (this.size && !avail.includes(this.size)) return false;
      if (this.size && !sizes.length) return false;
      if (this.stock && card.dataset.inStock !== 'true') return false;
      for (const key in this.filters) {
        const vals = this.filters[key];
        if (!vals.length) continue;
        if (key === 'price') {
          const p = parseInt(card.dataset.price || '0', 10);
          if (!vals.some(r => { const [a, b] = r.split('-').map(Number); return p >= a * 100 && p <= b * 100; })) return false;
        } else {
          const cv = (card.dataset[key] || '').toLowerCase();
          if (!vals.some(v => cv === v.toLowerCase())) return false;
        }
      }
      return true;
    }
    matching() { return this.cards().filter(c => this.matches(c)); }
    syncUrl() {
      if (!window.history || !history.replaceState) return;
      const url = new URL(window.location.href);
      if (this.size) url.searchParams.set('str', this.size); else url.searchParams.delete('str');
      history.replaceState(null, '', url.pathname + (url.search || '') + url.hash);
    }
    reset() {
      this.size = null;
      this.stock = false;
      this.filters = {};
      sizeStore.set(null, 'grid');
      $$('[data-filter-group] input[type="checkbox"]', this.root).forEach(c => { c.checked = false; });
      this.revealed = this.step;
      this.apply();
      this.syncUrl();
    }
    isFiltered() { return !!this.size || this.stock || Object.values(this.filters).some(v => v.length); }
    apply() {
      this.sizeButtons.forEach(b => {
        const on = b.dataset.filterSize === this.size;
        b.classList.toggle('is-selected', on);
        b.setAttribute('aria-pressed', on);
      });
      this.stockToggle && this.stockToggle.classList.toggle('is-active', this.stock);

      const hits = this.matching();
      const visible = Math.min(this.revealed, hits.length);
      this.cards().forEach(c => { c.hidden = true; });
      hits.slice(0, visible).forEach(c => { c.hidden = false; });

      this.cards().forEach(c => c.querySelectorAll('.size-chip').forEach(ch => {
        ch.classList.toggle('is-mine', !!this.size && ch.dataset.size === this.size && !ch.classList.contains('is-soldout'));
      }));

      const s = cfg.strings;
      const total = hits.length;
      if (this.countEl) this.countEl.textContent = this.size ? fmt(s.modelsInSize, { n: total, s: this.size }) : fmt(s.modelsTotal, { n: total });
      if (this.status) {
        this.status.textContent = total === 0 ? ''
          : (this.size ? fmt(s.shownInSize, { n: visible, total: total, s: this.size })
                       : fmt(s.shown, { n: visible, total: total }));
      }
      if (this.more) {
        const left = total - visible;
        this.more.hidden = left <= 0;
        var tpl = left <= this.step
          ? (this.more.dataset.moreLast || 'Vis de sidste [n]').replace('[n]', left)
          : (this.more.dataset.moreLabel || 'Vis [n] mere').replace('[n]', this.step);
        this.more.querySelector('span').textContent = tpl;
      }
      const empty = this.root.querySelector('[data-empty]');
      if (empty) {
        empty.hidden = total > 0 || !this.isFiltered();
        const label = empty.querySelector('[data-empty-size]');
        if (label) label.textContent = this.size ? ' i str. ' + this.size : '';
      }
      $$('[data-filter-reset]', this.root).forEach(b => {
        if (b.closest('[data-empty]')) return;
        b.hidden = !this.isFiltered();
      });
    }
  }
  boot('kategorifilter', () => $$('[data-collection]').forEach(r => new CollectionGrid(r)));

  /* ---------- Produktkort: hurtigvalg ---------- */
  document.addEventListener('click', e => {
    const chip = e.target.closest('.size-chip[data-url]');
    if (chip) { e.preventDefault(); window.location.href = chip.dataset.url; }
  });

  /* ---------- Nyhedsbrev-fokus (scroll fra "Skriv dig op") ---------- */
  document.addEventListener('click', e => {
    const a = e.target.closest('[data-scroll-to]');
    if (a) { const t = $(a.dataset.scrollTo); if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'center' }); const i = t.querySelector('input'); i && setTimeout(() => i.focus(), 400); } }
  });

  /* ---------- Header: skygge ved scroll ---------- */
  const header = $('.header');
  if (header) { const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 8); onScroll(); window.addEventListener('scroll', onScroll, { passive: true }); }
})();
